<template>
  <ReviewOfPacking ref="ReviewOfPacking"/>
</template>

<script>
import ReviewOfPacking from '@/pdaView/outbound/packing/ReviewOfPacking.vue'

export default {
  components: { ReviewOfPacking },
  props: {
    queryParam: { type: Object, default: null }
  },
  data() {
    return {
      device: true
    }
  }
}
</script>